// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3lk-7","itemTitle":"ClientEmergencyInfo_itemTitle__gKyBC","itemText":"ClientEmergencyInfo_itemText__1Lpld"};